import { Smartphone, QrCode } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface RedemptionTypeDisplayProps {
  value?: 'self' | 'barcode';
}

export function RedemptionTypeDisplay({ value }: RedemptionTypeDisplayProps) {
  const effectiveValue = value ?? 'barcode';

  if (effectiveValue === 'self') {
    return (
      <div className="flex items-center gap-3">
        <div
          className={cn(
            'flex h-10 w-10 shrink-0 items-center justify-center rounded-lg',
            'bg-primary/10 text-primary',
          )}
        >
          <Smartphone className="h-5 w-5" />
        </div>
        <div>
          <div className="font-medium">Self-Service</div>
          <div className="text-sm text-muted-foreground">
            User taps a button in the app to redeem
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <div
        className={cn(
          'flex h-10 w-10 shrink-0 items-center justify-center rounded-lg',
          'bg-primary/10 text-primary',
        )}
      >
        <QrCode className="h-5 w-5" />
      </div>
      <div>
        <div className="font-medium">Barcode Scan</div>
        <div className="text-sm text-muted-foreground">
          Staff scans user's barcode to redeem
        </div>
      </div>
    </div>
  );
}
